"use client"

import Image from "next/image"
import { useState } from "react"

type ProviderLogoImageProps = {
  src: string
  alt: string
}

/**
 * Client wrapper so onError can flip to text when a Blob PNG is missing.
 * Producers that don't yet have an uploaded logo show their name instead.
 */
export function ProviderLogoImage({ src, alt }: ProviderLogoImageProps) {
  const [failed, setFailed] = useState(false)

  if (failed) {
    return <span className="truncate text-center text-xs font-medium text-white/60">{alt}</span>
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={160}
      height={48}
      sizes="120px"
      className="h-8 w-auto max-h-8 object-contain brightness-0 invert md:h-12 md:max-h-12"
      onError={() => setFailed(true)}
    />
  )
}
